import { Chapter, PagePath } from '../app/shared/models/page-model';
import { CanActivateQuestionaireGuard } from '../app/shared/services/guards/can-activate-questionaire.guard';
import { CanActivatePostCoQxGuard } from '../app/shared/services/guards/can-activate-post-co-qx.guard';
const ɵ0 = () => import("./modules/name-desktop.module.ngfactory").then((m) => m.NameDesktopModuleNgFactory), ɵ1 = () => import("./modules/business-desktop.module.ngfactory").then((m) => m.BusinessDesktopModuleNgFactory), ɵ2 = () => import("./modules/included-desktop.module.ngfactory").then((m) => m.IncludedDesktopModuleNgFactory), ɵ3 = { preload: true, delay: 2 }, ɵ4 = () => import("./modules/essentials-desktop.module.ngfactory").then((m) => m.EssentialsDesktopModuleNgFactory), ɵ5 = { preload: true, delay: 4 }, ɵ6 = () => import("./modules/package-desktop.module.ngfactory").then((m) => m.PackageDesktopModuleNgFactory), ɵ7 = { preload: true, delay: 6 }, ɵ8 = () => import("./modules/checkout-desktop.module.ngfactory").then((m) => m.CheckoutDesktopModuleNgFactory), ɵ9 = { preload: true, delay: 8 }, ɵ10 = () => import("./modules/post-checkout.module.ngfactory").then((m) => m.PostCheckoutModuleNgFactory), ɵ11 = { preload: true, delay: 10 };
const classicRoutes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: Chapter.Name + '/' + PagePath.BusinessState,
    },
    {
        path: '',
        canActivate: [CanActivateQuestionaireGuard],
        children: [
            {
                path: Chapter.Name,
                loadChildren: ɵ0,
            },
            {
                path: Chapter.Business,
                loadChildren: ɵ1,
            },
            {
                path: Chapter.Services,
                loadChildren: ɵ2,
                data: ɵ3,
            },
            {
                path: Chapter.Essentials,
                loadChildren: ɵ4,
                data: ɵ5,
            },
            {
                path: Chapter.Package,
                loadChildren: ɵ6,
                data: ɵ7,
            },
            {
                path: Chapter.Checkout,
                loadChildren: ɵ8,
                data: ɵ9,
            },
            {
                path: Chapter.PostOrder,
                canActivate: [CanActivatePostCoQxGuard],
                // canActivateChild: [CheckoutBackButtonGuard], // TODO check the logic and apply this guard again
                loadChildren: ɵ10,
                data: ɵ11,
            },
        ],
    },
    { path: '**', redirectTo: Chapter.Name + '/' + PagePath.ChangeName },
];
const ɵ12 = () => import("./pl-features/glo-design/modules/glo-name-desktop.module.ngfactory").then((m) => m.GloNameDesktopModuleNgFactory), ɵ13 = { theme: 'glo' }, ɵ14 = () => import("./pl-features/glo-design/modules/glo-business-desktop.module.ngfactory").then((m) => m.GloBusinessDesktopModuleNgFactory), ɵ15 = { theme: 'glo' }, ɵ16 = () => import("./pl-features/glo-design/modules/glo-included-desktop.module.ngfactory").then((m) => m.GloIncludedDesktopModuleNgFactory), ɵ17 = { preload: true, delay: 2, theme: 'glo' }, ɵ18 = () => import("./pl-features/glo-design/modules/glo-essentials-desktop.module.ngfactory").then((m) => m.GloEssentialsDesktopModuleNgFactory), ɵ19 = { preload: true, delay: 4, theme: 'glo' }, ɵ20 = () => import("./pl-features/glo-design/modules/glo-package-desktop.module.ngfactory").then((m) => m.GloPackageDesktopModuleNgFactory), ɵ21 = { preload: true, delay: 6, theme: 'glo' }, ɵ22 = () => import("./pl-features/glo-design/modules/glo-checkout-desktop.module.ngfactory").then((m) => m.GloCheckoutDesktopModuleNgFactory), ɵ23 = { preload: true, delay: 8, theme: 'glo' }, ɵ24 = () => import("./pl-features/glo-design/modules/glo-post-checkout.module.ngfactory").then((m) => m.GloPostCheckoutModuleNgFactory), ɵ25 = { preload: true, delay: 10 };
const gloRoutes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: Chapter.Name + '/' + PagePath.BusinessState,
    },
    {
        path: '',
        canActivate: [CanActivateQuestionaireGuard],
        children: [
            {
                path: Chapter.Name,
                loadChildren: ɵ12,
                data: ɵ13,
            },
            {
                path: Chapter.Business,
                loadChildren: ɵ14,
                data: ɵ15,
            },
            {
                path: Chapter.Services,
                loadChildren: ɵ16,
                data: ɵ17,
            },
            {
                path: Chapter.Essentials,
                loadChildren: ɵ18,
                data: ɵ19,
            },
            {
                path: Chapter.Package,
                loadChildren: ɵ20,
                data: ɵ21,
            },
            {
                path: Chapter.Checkout,
                loadChildren: ɵ22,
                data: ɵ23,
            },
            {
                path: Chapter.PostOrder,
                canActivate: [CanActivatePostCoQxGuard],
                // canActivateChild: [CheckoutBackButtonGuard], // TODO check the logic and apply this guard again
                loadChildren: ɵ24,
                data: ɵ25,
            },
        ],
    },
    { path: '**', redirectTo: Chapter.Name + '/' + PagePath.ChangeName },
];
export const routeFactory = (experimentsService) => experimentsService.getGloDesignTest() ? gloRoutes : classicRoutes;
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25 };
